import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import { Box, Icon } from "@mui/material";
import {
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
} from "../../store/types/billTypes";
import { useNavigate } from "react-router";
import CoreH2 from "../../core/dataDisplay/CoreH2";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import { setBillReducer } from "../../store/actions/billActions";

export default function UserDocs() {
  const users = useSelector((state) => state.bill.userDocs);
  const user = useSelector((state) => state.auth.user);
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);

  const [open, setModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setModal(false);
    getData();
    dispatch(
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
    );
  }, []);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
    if (groupDocsError) {
      alert("Internal error");
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
  }, [groupDocsSuccess, groupDocsError]);

  const getData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/DocGroups",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ orgId: user.orgId }),
          ),
        },
        null,
        FETCH_DOC_USERS_SUCCESS,
        FETCH_DOC_USERS_ERROR,
        true,
        false,
      ),
    );
  };

  const viewDocs = (row) => {
    navigate("/education/docs/view", {
      state: { docGroupId: row.id, label: row.fieldValue },
    });
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  return (
    <Box style={{ width: "100%" }}>
      <Box style={{ padding: 16 }}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <CoreH6>Document Users</CoreH6>
          <CoreIconButton onClick={groupData}>
            <Icon>sync</Icon>
          </CoreIconButton>
        </Box>
        <CoreDataTable
          showToolbar={false}
          selectable={false}
          // dense={true}
          noOfRows={10}
          //   actions={
          //     job?.status === ENTITY_STATUS.completed
          //       ? [
          //           { icon: "download", onClick: onExportExcel },
          //           { icon: "delete", onClick: onDelete },
          //         ]
          //       : [{ icon: "delete", onClick: onDelete }]
          //   }
          rowActions={[
            { title: "View", icon: "chevron_right", onClick: viewDocs },
          ]}
          columns={[
            {
              view: (row) => {
                return row.fieldValue;
              },
              name: "name",
              label: "Name",
              width: "40%",
            },
            // {
            //   view: (row) => {
            //     return row._status;
            //   },
            //   name: "_status",
            //   label: "Status",
            //   width: 50,
            // },
            {
              view: (row) => {
                if (row.info?.criteria) {
                  if (row.info.criteria["10th Marks Check"]) {
                    return <Icon color="success">check_circle</Icon>;
                  } else {
                    return <Icon color="error">cancel</Icon>;
                  }
                } else return null;
              },
              name: "10th Check",
              label: "10th Check",
              width: "20%",
            },
            {
              view: (row) => {
                if (row.info?.criteria) {
                  if (row.info.criteria["12th Marks Check"]) {
                    return <Icon color="success">check_circle</Icon>;
                  } else {
                    return <Icon color="error">cancel</Icon>;
                  }
                } else return null;
              },
              name: "12th Check",
              label: "12th Check",
              width: "20%",
            },
            {
              view: (row) => {
                if (row.info?.criteria) {
                  if (row.info.criteria["Age check"]) {
                    return <Icon color="success">check_circle</Icon>;
                  } else {
                    return <Icon color="error">cancel</Icon>;
                  }
                } else return null;
              },
              name: "Age Check",
              label: "Age Check",
              width: "20%",
            },
          ]}
          dataRows={users || []}
        />
      </Box>
    </Box>
  );
}
